/*
 * Theme tokens for the Guild Hall / Ledger screens. Every value is a CSS variable so
 * the whole look swaps with the active skin (see src/styles/skins.css, useSkin).
 */
const v = (name: string) => `var(--pal-${name})`;

export const INK = v('ink');
export const PANEL = v('panel');
export const PANEL_GLASS = v('panel-glass');
export const RIM = v('rim');
export const ICE = v('text');
export const TEAL = v('muted');
export const WIN = v('win');
export const LOSS = v('loss');
export const ACCENT = v('accent');
export const GOLD = v('gold');
export const FIELD = v('field');
export const PAGE = v('page');

export const TITLE_FONT = v('title-font');
export const PX_FONT = v('ui-font');
export const NUM_FONT = v('num-font');

/* Stepped pixel border in the arcade skin; a quiet hairline card in flatter skins */
export const pixelFrame = (hot = false) => (hot ? v('frame-hot') : v('frame'));

export const arcadeTitleShadow = v('title-shadow');

/** Label casing: shouty pixel caps in arcade, sentence case in flatter skins */
export const CASE = v('case') as 'uppercase';
export const ON_ACCENT = v('on-accent');
export const FIELD_SHADOW = v('field-shadow');
export const TAB_ON = v('tab-on');
export const TAB_OFF = v('tab-off');
export const TITLE_WEIGHT = v('title-weight');
export const HEAD_SHADOW = v('head-shadow');
export const SOFT_TEXT = v('soft-text');
